export default __webpack_public_path__ + "static/media/logo-w.5d1c6b9e.svg";